import React, { PureComponent } from 'react';
import { Label, FormGroup, Col, Row } from 'reactstrap';
import { number, func } from 'prop-types';
import Select from '../../../../components/common/Select';
import { FMessage } from '../../../../hoc/IntlComponents';
import CustomControl from '../../../../components/CustomControl/CustomControl';

const propTypes = {
    method: number.isRequired,
    onPostbackMethodChange: func.isRequired,
};

const defaultProps = {
    method: 0,
};

const methods = [
    {
        value: 0,
        label: 'POST',
    },
    {
        value: 1,
        label: 'GET',
    }
];

class FlowPostbackMethod extends PureComponent {
    state = {
        checked: false
    }
    render() {
        const { selectedMethod, onPostbackMethodChange } = this.props;

        return (
            <FormGroup className='method'>
                <Col lg='4' md='4' sm='12'>
                    <Label className='method-title' for="postback-method">
                        <FMessage id="postback.global.method" />
                    </Label>
                </Col>
                <Col lg='8' md='8' sm='12'>
                    {methods.map(method => <CustomControl
                        key={method.value}
                        id={`postback-method-${method.value}`}
                        label={method.label}
                        className="custom-control-xs"
                        type='checkbox'
                        value={method.value}
                        checked={method.value === selectedMethod}
                        onChange={() => onPostbackMethodChange({ method: method.value })}
                    />)}
                </Col>
            </FormGroup>
        );
    }
}

FlowPostbackMethod.propTypes = propTypes;
FlowPostbackMethod.defaultProps = defaultProps;

export default FlowPostbackMethod;
